export const GOVERNED_LOOKUP_FAILURES = {
  noEvidenceLookup: 'no_evidence_lookup', toolsUnavailable: 'tools_unavailable',
  lookupsRefused: 'lookups_refused',
  answerTargetUnmatched: 'answer_target_unmatched',
} as const;
export type GovernedLookupFailure = typeof GOVERNED_LOOKUP_FAILURES[keyof typeof GOVERNED_LOOKUP_FAILURES];

/** Public service failure; never a user login error or an authored answer. */
export const ASK_HELIX_PROVIDER_AUTHENTICATION_FAILURE = {
  code: 'provider_authentication_failed',
  message:
    'Helix could not authenticate with its answer service. Please contact your workspace administrator.',
  retryable: false,
} as const;

export const ASK_HELIX_PROVIDER_ACCESS_DENIED_FAILURE = {
  code: 'provider_access_denied',
  message:
    'Helix cannot access its answer service. Please contact your workspace administrator.',
  retryable: false,
} as const;

export const ASK_HELIX_PROVIDER_QUOTA_EXHAUSTED_FAILURE = {
  code: 'provider_quota_exhausted',
  message:
    'Helix cannot complete this request because its answer service quota is exhausted. Please contact your workspace administrator.',
  retryable: false,
} as const;

export const ASK_HELIX_PROVIDER_PROTOCOL_ERROR_FAILURE = {
  code: 'provider_protocol_error',
  message: 'The answer service returned an invalid response. This request could not be completed.',
  retryable: false,
} as const;

export const ASK_HELIX_PROVIDER_RATE_LIMITED_FAILURE = {
  code: 'provider_rate_limited',
  message:
    'Helix is busy; try again in a moment.',
  retryable: true,
} as const;

export const ASK_HELIX_PROVIDER_UNAVAILABLE_FAILURE = {
  code: 'provider_unavailable',
  message:
    'Helix cannot complete this request because its answer service is temporarily unavailable. Please try again shortly.',
  retryable: true,
} as const;

export const ASK_HELIX_PROVIDER_FAILURES = [
  ASK_HELIX_PROVIDER_AUTHENTICATION_FAILURE,
  ASK_HELIX_PROVIDER_ACCESS_DENIED_FAILURE,
  ASK_HELIX_PROVIDER_QUOTA_EXHAUSTED_FAILURE,
  ASK_HELIX_PROVIDER_PROTOCOL_ERROR_FAILURE,
  ASK_HELIX_PROVIDER_RATE_LIMITED_FAILURE,
  ASK_HELIX_PROVIDER_UNAVAILABLE_FAILURE,
] as const;

export type AskHelixProviderFailure = (typeof ASK_HELIX_PROVIDER_FAILURES)[number];

export function askHelixProviderFailureForCode(
  code: unknown,
): AskHelixProviderFailure | null {
  return (
    ASK_HELIX_PROVIDER_FAILURES.find((failure) => failure.code === code) ?? null
  );
}
